/* S4Y5-STUHL-1 · Stuhl-Produktseite (sections/s4y-v5-pdp-stuhl.liquid): Galerie, Menge, Varianten, weitere Farben · 13.10.2026 */
(function () {
  function kopf(t) {
    t = (t || '').trim();
    if (t.indexOf(' – ') > -1) return t.split(' – ')[0].trim();
    if (t.indexOf(' - ') > -1) {
      var a = t.split(' - '), l = a[a.length - 1].trim().toLowerCase();
      if (/drehbar|wunschstoff|stück|°/.test(l)) return t;
      return a.slice(0, -1).join(' - ').trim();
    }
    return t;
  }
  function farbeVon(t) {
    t = (t || '').trim();
    if (t.indexOf(' – ') > -1) return t.slice(t.indexOf(' – ') + 3).trim();
    if (t.indexOf(' - ') > -1) {
      var a = t.split(' - '), l = a[a.length - 1].trim();
      if (/drehbar|wunschstoff|stück|°/.test(l.toLowerCase())) return '';
      return l;
    }
    return '';
  }

  function init(root) {
    if (root.getAttribute('data-s5pdp-init')) return;
    root.setAttribute('data-s5pdp-init', '1');
    var ds = root.dataset;
    function alle(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

    /* ---------- Galerie ---------- */
    var track = root.querySelector('[data-s5pdp-track]');
    var slides = track ? alle('.s5pdp__slide', track) : [];
    var n = slides.length, cur = 0;
    var dots = alle('[data-s5pdp-dot]'), thumbs = alle('[data-s5pdp-thumb]');
    var zahl = root.querySelector('[data-s5pdp-zahl]');
    var prev = root.querySelector('[data-s5pdp-prev]'), next = root.querySelector('[data-s5pdp-next]');
    function mark(i) {
      cur = i;
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
      thumbs.forEach(function (t) {
        var on = parseInt(t.getAttribute('data-s5pdp-thumb'), 10) === i;
        t.classList.toggle('is-on', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (zahl) zahl.textContent = (i + 1) + ' / ' + n;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= n - 1;
    }
    /* Eigene kurze Animation statt scrollTo smooth: Chrome bricht weiches Scrollen ab, sobald sich das Layout ändert
       (Klarna, Countdown in der Leiste) – während der Animation ist das Einrasten deshalb kurz aus. */
    var anim = null;
    function go(i, glatt) {
      if (!track || !n) return;
      i = Math.max(0, Math.min(n - 1, i));
      var ziel = i * track.clientWidth, start = track.scrollLeft, weg = ziel - start;
      mark(i);
      if (anim) { cancelAnimationFrame(anim); anim = null; }
      track.style.scrollSnapType = 'none';
      if (!glatt || Math.abs(weg) < 2 || !window.requestAnimationFrame) {
        track.scrollLeft = ziel;
        track.style.scrollSnapType = '';
        return;
      }
      var t0 = null, dauer = 320;
      function schritt(ts) {
        if (t0 === null) t0 = ts;
        var k = Math.min(1, (ts - t0) / dauer);
        track.scrollLeft = start + weg * (1 - Math.pow(1 - k, 3));
        if (k < 1) { anim = requestAnimationFrame(schritt); return; }
        anim = null;
        track.scrollLeft = ziel;
        track.style.scrollSnapType = '';
      }
      anim = requestAnimationFrame(schritt);
    }
    if (track && n > 1) {
      var tick = false;
      track.addEventListener('scroll', function () {
        if (tick || anim) return;
        tick = true;
        requestAnimationFrame(function () {
          tick = false;
          var w = track.clientWidth || 1;
          var i = Math.round(track.scrollLeft / w);
          if (i !== cur && i >= 0 && i < n) mark(i);
        });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1, true); }
      });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-s5pdp-thumb'), 10), true); }); });
      if (prev) prev.addEventListener('click', function () { go(cur - 1, true); });
      if (next) next.addEventListener('click', function () { go(cur + 1, true); });
      var breite = track.clientWidth;
      window.addEventListener('resize', function () {
        if (track.clientWidth === breite) return;
        breite = track.clientWidth;
        go(cur, false);
      });
    }
    function zuBild(mediaId) {
      if (!mediaId) return;
      for (var i = 0; i < n; i++) {
        if (slides[i].getAttribute('data-s5pdp-media') === String(mediaId)) { go(i, true); return; }
      }
    }

    /* ---------- Menge ---------- */
    var menge = root.querySelector('[data-s5pdp-menge]');
    alle('[data-s5pdp-q]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!menge) return;
        var x = (parseInt(menge.value, 10) || 1) + parseInt(b.getAttribute('data-s5pdp-q'), 10);
        menge.value = Math.max(1, x);
      });
    });

    /* ---------- Varianten (nur bei Produkten mit mehreren Varianten) ---------- */
    var V = [];
    try {
      V = JSON.parse(root.querySelector('[data-s5pdp-v]').textContent).map(function (v) {
        return { id: v.id, o: v.options || [], p: v.price, c: v.compare_at_price || 0, a: !!v.available, m: v.featured_media ? v.featured_media.id : 0 };
      });
    } catch (e) { V = []; }
    var vid = root.querySelector('[data-s5pdp-vid]');
    var groups = alle('[data-s5pdp-opt]');
    var sel = [];
    V.forEach(function (x) { if (vid && String(x.id) === String(vid.value)) sel = x.o.slice(); });
    var fmt = null;
    try { fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }); } catch (e) {}
    function geld(c) {
      var s = fmt ? fmt.format(c / 100) : (c / 100).toFixed(2).replace('.', ',') + ' €';
      return s.replace(',00', '').split(String.fromCharCode(160)).join(' ');
    }
    function finde() {
      for (var i = 0; i < V.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) { if (V[i].o[j] !== sel[j]) { ok = false; break; } }
        if (ok) return V[i];
      }
      return null;
    }
    function setze(v) {
      sel = v.o.slice();
      groups.forEach(function (g) {
        var gi = parseInt(g.getAttribute('data-s5pdp-opt'), 10);
        alle('[data-s5pdp-val]', g).forEach(function (b) {
          var on = b.getAttribute('data-s5pdp-val') === sel[gi];
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var nm = g.querySelector('[data-s5pdp-optname]');
        if (nm) nm.textContent = sel[gi];
      });
      if (vid) vid.value = v.id;
      var now = root.querySelector('[data-s5pdp-now]'), was = root.querySelector('[data-s5pdp-was]'), badge = root.querySelector('[data-s5pdp-badge]');
      var r = v.c > v.p ? Math.round((v.c - v.p) * 100 / v.c) : 0;
      if (now) now.textContent = geld(v.p);
      if (was) { was.textContent = r ? geld(v.c) : ''; was.hidden = !r; }
      if (badge) { badge.textContent = r ? '−' + r + ' %' : ''; badge.hidden = !r; }
      var atc = root.querySelector('[data-s5pdp-atc]');
      if (atc) {
        atc.disabled = !v.a;
        var t = atc.querySelector('span');
        if (t) t.textContent = v.a ? 'In den Warenkorb' : 'Ausverkauft';
      }
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', u.toString());
      } catch (e) {}
      zuBild(v.m);
      var kl = root.querySelector('klarna-placement');
      if (kl) {
        kl.setAttribute('data-purchase-amount', v.p);
        try { if (window.Klarna && window.Klarna.OnsiteMessaging) window.Klarna.OnsiteMessaging.refresh(); } catch (e) {}
      }
    }
    groups.forEach(function (g) {
      var gi = parseInt(g.getAttribute('data-s5pdp-opt'), 10);
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-s5pdp-val]');
        if (!b) return;
        sel[gi] = b.getAttribute('data-s5pdp-val');
        var v = finde();
        if (!v) { for (var i = 0; i < V.length; i++) { if (V[i].o[gi] === sel[gi]) { v = V[i]; break; } } }
        if (v) setze(v);
      });
    });

    /* ---------- Weitere Farben: eigene Produkte mit gleichem Titelanfang (Shopify-Suche) ---------- */
    var wahl = root.querySelector('[data-s5pdp-farbwahl]');
    var reihe = root.querySelector('[data-s5pdp-farben]');
    var fname = root.querySelector('[data-s5pdp-farbname]');
    var aktuell = root.querySelector('[data-s5pdp-aktuell]');
    if (aktuell) aktuell.addEventListener('click', function (e) { e.preventDefault(); });
    if (!wahl || !reihe) return;
    /* Findet die Seite keine weiteren Farben, darf die Farb-App (Webyze) ihre Auswahl zeigen – dann ohne doppelte Reihe */
    function rueckfall() {
      root.classList.add('s5pdp--webyze');
      function pruefe() {
        var w = root.querySelectorAll('.webyzeProductColors .swatchProductColor').length;
        if (w >= 2) wahl.hidden = true;
        return w >= 2;
      }
      if (pruefe() || !window.MutationObserver) return;
      var mo = new MutationObserver(function () { if (pruefe()) mo.disconnect(); });
      mo.observe(root, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 15000);
    }
    if (!ds.kopf || !ds.suche || !window.fetch) { rueckfall(); return; }
    var view = '';
    try { view = new URLSearchParams(window.location.search).get('view') || ''; } catch (e) {}
    var q = ds.kopf.replace(/[^0-9A-Za-zÄÖÜäöüß ]+/g, ' ').trim().split(' ').filter(Boolean).slice(0, 2).join(' ');
    var url = ds.suche + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][fields]=title&resources[options][unavailable_products]=last';
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) {
      var liste = (((d || {}).resources || {}).results || {}).products || [];
      var gleich = [], ids = {};
      liste.forEach(function (x) {
        if (!x || ids[x.id] || kopf(x.title) !== ds.kopf) return;
        ids[x.id] = 1;
        gleich.push(x);
      });
      if (!ids[ds.id]) gleich.push({ id: ds.id, title: ds.titel, url: ds.url, featured_image: { url: ds.bild } });
      if (gleich.length < 2) { rueckfall(); return; }
      gleich.forEach(function (x) { x.lbl = String(x.id) === String(ds.id) ? (ds.farbe || '') : farbeVon(x.title); });
      gleich.sort(function (a, b) { return (a.lbl || a.title).localeCompare(b.lbl || b.title, 'de'); });
      var frag = document.createDocumentFragment();
      gleich.forEach(function (x) {
        var istAkt = String(x.id) === String(ds.id);
        var a = document.createElement('a');
        a.className = 's5pdp__tile' + (istAkt ? ' is-on' : '');
        var href = (x.url || '').split('?')[0];
        a.href = href + (view && !istAkt ? '?view=' + encodeURIComponent(view) : '');
        a.title = x.lbl || x.title || '';
        a.setAttribute('aria-label', x.lbl || x.title || '');
        if (istAkt) {
          a.setAttribute('aria-current', 'true');
          a.addEventListener('click', function (e) { e.preventDefault(); });
        }
        var src = x.featured_image && x.featured_image.url ? x.featured_image.url : (typeof x.image === 'string' ? x.image : '');
        if (src) {
          if (src.indexOf('width=') < 0) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
          var im = document.createElement('img');
          im.src = src; im.alt = ''; im.loading = 'lazy'; im.width = 64; im.height = 64;
          a.appendChild(im);
        }
        if (fname) {
          a.addEventListener('mouseenter', function () { fname.textContent = x.lbl || ''; });
          a.addEventListener('mouseleave', function () { fname.textContent = ds.farbe || ''; });
        }
        frag.appendChild(a);
      });
      reihe.innerHTML = '';
      reihe.appendChild(frag);
      wahl.hidden = false;
    }).catch(function () { rueckfall(); });
  }

  function start() { Array.prototype.forEach.call(document.querySelectorAll('[data-s5pdp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();